import { Assets, Texture } from 'pixi.js';
import { sound, Sound, Options as SoundOptions, PlayOptions } from '@pixi/sound';

type TextureConfig = {
  name: string;
  url: string;
};

type SoundConfig = {
  name: string;
  url: string;
  options?: SoundOptions;
};

export class AssetManager {
  private static instance: AssetManager;
  private textures: Map<string, Texture> = new Map();
  private sounds: Map<string, Sound> = new Map();

  private constructor() {}

  public static getInstance(): AssetManager {
    if (!AssetManager.instance) {
      AssetManager.instance = new AssetManager();
    }

    return AssetManager.instance;
  }

  public async loadTextures(configs: TextureConfig[]): Promise<void> {
    const promises = configs.map(async ({ name, url }) => {
      const texture = await Assets.load<Texture>(url);
      this.textures.set(name, texture);
    });

    await Promise.all(promises);
  }

  public async loadSounds(configs: SoundConfig[]): Promise<void> {
    const promises = configs.map(async ({ name, url, options }) => {
      if (!sound.exists(name)) {
        await sound.add(name, {
          url,
          ...options
        });
      }
      const instance = sound.find(name);
      if (instance) {
        this.sounds.set(name, instance as Sound);
      }
    });

    await Promise.all(promises);
  }

  public getTexture(name: string): Texture | undefined {
    return this.textures.get(name);
  }

  public playSound(name: string, options?: PlayOptions): void {
    if (this.sounds.has(name)) {
      sound.play(name, options);
    }
  }

  public stopSound(name: string): void {
    if (this.sounds.has(name)) {
      sound.stop(name);
    }
  }
}
